
export default function Cookies() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-[#0A66C2]" style={{ fontFamily: '"Pacifico", serif' }}>
                StarSales
              </a>
            </div>
            <div className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Home</a>
              <a href="/over-ons" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Over ons</a>
              <a href="/contact" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Contact</a>
            </div>
            <div className="flex items-center space-x-4">
              <a href="tel:097010224137" className="text-[#0A66C2] hover:text-[#F57C00] font-medium transition-colors">
                0970 102 241 37
              </a>
              <button className="bg-[#F57C00] text-white px-4 py-2 rounded-full font-medium hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer">
                Gratis check
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#0A66C2] to-[#1976D2] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
            Cookieverklaring
          </h1>
          <p className="text-xl text-blue-100" style={{ fontFamily: '"Inter", sans-serif' }}>
            Transparantie over het gebruik van cookies op onze website
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100">
            {/* Header */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Cookieverklaring – StarSales B.V.
              </h2>
              <p className="text-gray-600 font-medium">
                Laatst bijgewerkt: 12/02/2025
              </p>
            </div>

            {/* Content */}
            <div className="prose prose-lg max-w-none" style={{ fontFamily: '"Inter", sans-serif' }}>
              {/* Section 1 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                  Wat zijn cookies?
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Cookies zijn kleine tekstbestanden die bij het bezoek aan een website op je computer, tablet of smartphone worden geplaatst. Ze zorgen ervoor dat de website goed werkt en helpen ons om inzicht te krijgen in het gebruik van de website, zodat wij onze diensten kunnen verbeteren.
                </p>
              </div>

              {/* Section 2 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                  Welke cookies gebruiken wij?
                </h3>
                
                <div className="space-y-6">
                  <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-[#0A66C2]">
                    <h4 className="font-bold text-gray-900 mb-2">a) Functionele cookies</h4>
                    <p className="text-gray-700">
                      Deze cookies zijn noodzakelijk voor de werking van onze website. Ze onthouden bijvoorbeeld je voorkeuren (zoals taalinstellingen) en zorgen dat formulieren goed functioneren.
                    </p>
                  </div>

                  <div className="bg-green-50 p-6 rounded-lg border-l-4 border-green-500">
                    <h4 className="font-bold text-gray-900 mb-2">b) Analytische cookies</h4>
                    <p className="text-gray-700">
                      Met analytische cookies (bijv. Google Analytics) krijgen wij inzicht in hoe bezoekers onze website gebruiken. Denk aan bezochte pagina's, gebruikte browsers en klikgedrag. Deze gegevens zijn anoniem en worden uitsluitend gebruikt om de website te verbeteren.
                    </p>
                  </div>

                  <div className="bg-orange-50 p-6 rounded-lg border-l-4 border-[#F57C00]">
                    <h4 className="font-bold text-gray-900 mb-2">c) Marketingcookies</h4>
                    <p className="text-gray-700">
                      Marketingcookies gebruiken we om advertenties te personaliseren en af te stemmen op jouw interesses, bijvoorbeeld via Google Ads of social media platforms zoals Facebook en Instagram. Hiermee kunnen wij gerichter adverteren en relevante aanbiedingen tonen.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section 3 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                  Toestemming
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Bij je eerste bezoek aan onze website tonen wij een cookiebanner. Hier kun je aangeven of je alleen functionele cookies accepteert of ook analytische en marketingcookies. Je kunt je toestemming op elk moment wijzigen of intrekken via de cookie-instellingen van je browser.
                </p>
              </div>

              {/* Section 4 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                  Cookies beheren of verwijderen
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Je kunt cookies eenvoudig verwijderen of beheren via de instellingen van je internetbrowser. Let op: als je alle cookies blokkeert, kan de website minder goed functioneren.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Meer informatie over het uitschakelen van cookies vind je op:
                </p>
                <div className="mt-3">
                  <a 
                    href="https://www.veiliginternet.nl/cookies-beheren/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-[#0A66C2] hover:text-[#F57C00] font-medium transition-colors"
                  >
                    <i className="ri-external-link-line mr-2"></i>
                    Veilig Internetten – Cookies beheren
                  </a>
                </div>
              </div>

              {/* Section 5 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                  Wijzigingen
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  StarSales B.V. kan deze cookieverklaring aanpassen als onze diensten of wetgeving veranderen. We adviseren daarom deze pagina regelmatig te raadplegen.
                </p>
              </div>

              {/* Section 6 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">6</span>
                  Contact
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Heb je vragen over ons cookiebeleid? Neem gerust contact met ons op:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <div className="space-y-2 text-gray-700">
                    <p className="font-semibold text-gray-900">StarSales B.V.</p>
                    <p>Mgr. Cornelis Veermanlaan 63</p>
                    <p>1131 KE Volendam – Nederland</p>
                    <p>
                      Telefoon: 
                      <a href="tel:097010224137" className="text-[#0A66C2] hover:text-[#F57C00] font-medium ml-1 transition-colors">
                        0970 102 241 37
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Section */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  Vragen over onze cookies?
                </h3>
                <p className="text-gray-600 mb-6">
                  Neem contact met ons op voor meer informatie over ons cookiebeleid.
                </p>
                <a 
                  href="/contact" 
                  className="inline-flex items-center bg-[#F57C00] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-line mr-2"></i>
                  Contact opnemen
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center mb-6">
                <span className="text-3xl font-bold text-[#0A66C2]" style={{ fontFamily: '"Pacifico", serif' }}>
                  StarSales
                </span>
              </div>
              <p className="text-gray-300 mb-6 max-w-md" style={{ fontFamily: '"Inter", sans-serif' }}>
                StarSales B.V. helpt ZZP en kleine bedrijven groeien met websites, Google Ads, social media advertenties en meer.
              </p>
              <div className="space-y-2 text-gray-300">
                <p>Mgr. Cornelis Veermanlaan 63</p>
                <p>1131 KE Volendam</p>
                <p>KvK: 97377562</p>
                <p>Tel: 0970 102 241 37</p>
                <p>E-mail: info@starsales.nl</p>
              </div>
            </div>
            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Diensten
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Websites</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Google Ads</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Social Media Ads</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">SEO</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Hosting</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Links
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li><a href="/privacy" className="hover:text-[#F57C00] transition-colors">Privacy</a></li>
                <li><a href="/cookies" className="hover:text-[#F57C00] transition-colors">Cookies</a></li>
                <li><a href="/voorwaarden" className="hover:text-[#F57C00] transition-colors">Voorwaarden</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 StarSales B.V. Alle rechten voorbehouden.
            </p>
            <div className="flex space-x-4 mt-5 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
